import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Button,
  Modal
} from 'react-bootstrap';
import { Data } from '@eduardosmatheus/react-data-grid-addons/dist/react-data-grid-addons'; // '../../dependencies/react-data-grid-addons';
import ReactDataGrid from '@eduardosmatheus/react-data-grid/dist/react-data-grid';
import CustomHeaderFormatter from './CustomHeaderFormatter';
import NumeralFormatter from '../NumeralFormatter';
import {
  SummaryCount, SummaryAverage, SummaryDistinctCount, SummarySum
} from '../Summary';
import {
  DateFormatter,
  TimestampFormatter,
  DatetimeFormatter,
  TimeFormatter,
} from './formatters/DateFormater';
import ProgressBarFormatter from './formatters/ProgressBarFormatter';
import SimpleCellFormatter from './formatters/SimpleCellFormatter';
import CustomRowRenderer from './CustomRowRenderer';
import GridContextMenu from './GridContextMenu';
import Alert from '../Alert/Alert';
const createProfile = () => {};
const updateHintsDef = () => {};
const changeProfile = () => {};
const getProfiles = () => {};
const getGridDef = () => {};
const updateColumns = () => {};

/**
 * Inject max-content width to make cell auto-resizable.
 *
 * @param {*} Component
 */
function withContentSize(Component) {
  return function ComponentWithMaxContent({ style, ...rest }) {
    return <Component {...rest} style={{ ...style, width: 'max-content' }} />;
  };
}

const AutoResizableDateFormatter = withContentSize(DateFormatter);
const AutoResizableTimestampFormatter = withContentSize(TimestampFormatter);
const AutoResizableDatetimeFormatter = withContentSize(DatetimeFormatter);
const AutoResizableTimeFormatter = withContentSize(TimeFormatter);
const AutoResizableProgressBarFormatter = withContentSize(ProgressBarFormatter);
const AutoResizableSimpleFormatter = withContentSize(SimpleCellFormatter);

const onChangeSortDefault = (initialRows, sortDirection, { key, type, toOption = data => data, getValueToSort = ({ value }) => value }) => rows => {
  const comparer = (a, b) => {
    const aColumn = a[key];
    const bColumn = b[key];
    const aProperty = type === 'object' ? getValueToSort(toOption(aColumn)) : aColumn;
    const bProperty = type === 'object' ? getValueToSort(toOption(bColumn)) : bColumn;
    if (aProperty === bProperty) return 0;
    if (sortDirection === "ASC") {
      return aProperty > bProperty ? 1 : -1;
    } else if (sortDirection === "DESC") {
      return aProperty < bProperty ? 1 : -1;
    }
  };
  return sortDirection === "NONE" ? initialRows : [...rows].sort(comparer);
};

class Grid extends Component {
  static propTypes = {
    data: PropTypes.array,
    rawColumnsDef: PropTypes.array,
    handleRowChange: PropTypes.func,
    minHeight: PropTypes.number,
    onRowsSelected: PropTypes.func,
    onRowsDeselected: PropTypes.func,
    indexes: PropTypes.array,
    enableSummary: PropTypes.bool,
    showCheckbox: PropTypes.bool,
    reflectShadowRows: PropTypes.func,
    gridName: PropTypes.string,
    onChangeSort: PropTypes.func,
    highlightActiveRow: PropTypes.bool,
    getClassName: PropTypes.func,
    onCellUpdated: PropTypes.func,
    sortable: PropTypes.bool,
    mantainFilters: PropTypes.bool,
    editableOptions: PropTypes.object,
    rowRenderer: PropTypes.node,
  }

  static defaultProps = {
    data: [],
    rawColumnsDef: [],
    handleRowChange: () => { },
    minHeight: 50,
    onRowsSelected: () => { },
    onRowsDeselected: () => { },
    enableSummary: false,
    showCheckbox: false,
    reflectShadowRows: null,
    indexes: [],
    gridName: '',
    onChangeSort: onChangeSortDefault,
    highlightActiveRow: false,
    getClassName: null,
    onCellUpdated: () => { },
    sortable: true,
    mantainFilters: false,
    editableOptions: undefined,
    rowRenderer: null,
    rowHeight: 25,
  }

  state = {
    columnsDef: [],
    rawColumnsDef: [],
    rowIdx: -1,
    filters: '',
    showAddPerfil: false,
    showConfig: false,
    showContextMenu: false,
    contextMenuX: null,
    contextMenuY: null,
    currentProfile: null,
    showAlertMessage: false,
    alertMessage: '',
    rowUpdatedAlert: false,
    saveRowUpdated: () => { },
    profiles: [],
    shadowRows: [],
    rows: [],
    sortDirection: null,
    sortColumn: null,
    dataChanged: false,
    showHint: false,
    hintsDef: []
  };

  componentDidMount() {
    const columnsDef = this.getColumns(this.props.rawColumnsDef);
    this.setState({ columnsDef });
  }
  /*
  componentDidMount() {
    getGridDef(this.props.gridName)
      .then((res) => {
        const profileId = res.data.currentProfile ? res.data.currentProfile : -1;
        const columnsDef = this.getColumns(res.data.columnsDef);
        this.setState({
          columnsDef,
          hintsDef: this.getHintsDef(columnsDef),
          rawColumnsDef: columnsDef,
          currentProfile: profileId,
          profiles: res.data.profiles
        }, () => {
          this.hackRDGridRender();
        });
      });
  } */

  static getDerivedStateFromProps(props, state) {
    if (!_.isEqual(state.rows, props.data)) {
      return {
        rows: props.data,
        shadowRows: props.data,
        filters: props.mantainFilters ? state.filters : '',
        rowIdx: -1,
        dataChanged: true
      };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.editableOptions !== prevProps.editableOptions) {
      this.reflectColumns(this.props.rawColumnsDef);
    }
    if (this.props.reflectShadowRows
      && this.state.shadowRows.length !== prevState.shadowRows.length) {
      this.props.reflectShadowRows(this.state.shadowRows);
    }

    if (this.state.shadowRows.size !== prevState.shadowRows.size
      && prevState.shadowRows.size === 0) {
      this.cleanFilters();
    }

    if (this.props.mantainFilters) this.applyFiltersByRef();
    else this.cleanFiltersByRef();
  }

  onClearFilters = () => {
    this.setState({ filters: '' });
  };

  onCellSelected = ({ rowIdx }) => {
    if (this.state.rowIdx !== rowIdx) {
      const data = this.state.shadowRows[rowIdx];
      this.props.handleRowChange(data);
      this.setState({ rowIdx });
    }
  }

  onContextMenu = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({
      showContextMenu: true,
      contextMenuX: e.pageX,
      contextMenuY: e.pageY
    });
  }

  getSummary = (summaryType) => {
    switch (`${summaryType}`) {
      case '1': return SummaryCount;
      case '2': return SummaryDistinctCount;
      case '3': return SummaryAverage;
      case '4': return SummarySum;
      default: return null;
    }
  }

  getColumns = (definitions) => {
    this.customHeaderRefs = [];
    return definitions
      .filter(column => !column.hidden)
      .map((column) => {
        const columnRef = React.createRef();
        this.customHeaderRefs = [...this.customHeaderRefs, columnRef];

        const virtualColumn = column;

        virtualColumn.headerRenderer = (
          <CustomHeaderFormatter
            headerRef={columnRef}
            onFilterChange={this.handleFilterChange}
            getValidFilterValues={this.getValidFilterValues}
          />
        );
        if (!column.summary) {
          virtualColumn.summary = this.getSummary(column.summary_index);
        }

        virtualColumn.formatter = column.formatter
          ? column.formatter
          : this.getDefaultFormatters(column.formatter_index, column)

        virtualColumn.width = column.width || null;
        virtualColumn.frozen = column.frozen;
        const { EditorComponent } = virtualColumn;
        const { editableOptions = {} } = this.props;
        const options = editableOptions[column.key];
        // I think that the editor property should be cloned with React.cloneElement().
        // For this moment, I opted by always render a new editor component.
        // I guess that on the next steps this element will be cloned to inject the cell Props.
        const editorOptionsKey = typeof options === 'function' ? 'loadOptions' : 'options';
        const editorProps = { [editorOptionsKey]: options };
        virtualColumn.editor = (EditorComponent && <EditorComponent {...editorProps} />) || undefined;
        return virtualColumn;
      });
  }

  getDefaultFormatters(formatterId, column) {
    if (formatterId === 1) {
      return v => NumeralFormatter({
        value: v.value,
        decimalScale: column.scale,
        columnKey: column.key
      });
    } else if (formatterId === 2) {
      return AutoResizableDateFormatter;
    } else if (formatterId === 3) {
      return AutoResizableTimestampFormatter;
    } else if (formatterId === 4) {
      return AutoResizableDatetimeFormatter;
    } else if (formatterId === 5) {
      return AutoResizableTimeFormatter;
    } else if (formatterId === 6) {
      return AutoResizableProgressBarFormatter;
    } else {
      return AutoResizableSimpleFormatter;
    }
  }

  getHintsDef = (columnsDef) => {
    return columnsDef.map((def) => {
      return { id: def.id_grid_column, key: def.name, hint: def.hint };
    });
  }

  getValidFilterValues = (columnId) => {
    const rows = Data.Selectors.getRows(this.state);
    return rows.map(r => r[columnId]);
  };

  handleHintChange = (currentHint) => {
    this.setState(state => ({
      hintsDef: state.hintsDef.map((def) => {
        if (currentHint.id === def.id) {
          return { ...def, hint: currentHint.hint };
        }
        return def;
      })
    }));
  }

  addPerfil = (e) => {
    e.preventDefault();
    createProfile(this.props.gridName, {
      first: e.target.profileName.value,
      second: this.state.rawColumnsDef
    }).then((res) => {
      const newProfile = res.data.first;
      const newColumns = res.data.second;
      this.setState(state => ({
        showAddPerfil: false,
        showConfig: true,
        profiles: [...state.profiles, newProfile],
        profileId: newProfile.id,
        rawColumnsDef: newColumns,
        columnsDef: this.getColumns(newColumns)
      }));
    });
  }

  handleSaveHintsDef = () => {
    const { currentProfile, hintsDef } = this.state;
    const normalizedHints = hintsDef.map(x => ({ ...x, hint: x.hint || '' }));
    updateHintsDef(currentProfile, this.props.gridName, normalizedHints)
      .then((res) => {
        const newColumns = res.data;
        this.setState({
          showHint: false,
          rawColumnsDef: newColumns,
          columnsDef: this.getColumns(newColumns)
        });
      });
  }

  cleanFiltersByRef = () => {
    if (this.customHeaderRefs) {
      this.customHeaderRefs.forEach((header) => {
        if (header.current) header.current.clean();
      });
    }
  }

  applyFiltersByRef = () => {
    if (this.customHeaderRefs) {
      this.customHeaderRefs.forEach((header) => {
        if (header.current) header.current.onConfirm();
      });
    }
  }

  cleanFilters = () => {
    this.setState((state, props) => ({
      rows: props.data,
      shadowRows: props.data,
      filters: ''
    }), this.cleanFiltersByRef);
  };

  handleFilterChange = (filter) => {
    if (filter) {
      const newFilters = { ...this.state.filters };
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState(state => ({
        filters: { ...state.filters, ...newFilters }
      }), () => {
        this.setState(state => ({
          shadowRows: Data.Selectors.getRows(state),
          rowIdx: -1
        }));
      });
    }
  };

  handleGridSort = (sortColumn, sortDirection) => {
    if (this.props.sortable) {
      const { columnsDef } = this.state;
      const column = columnsDef.find(({ key }) => key === sortColumn);
      const shadowRows = this.props.onChangeSort(this.props.data, sortDirection, column)(Data.Selectors.getRows(this.state));
      this.setState({ shadowRows });
    }
  };

  handleChangeColunsDef = (items) => {
    this.setState({ rawColumnsDef: items });
  }

  handleGridRowsUpdated = ({ fromRow, updated, cellKey }) => {
    const rows = this.state.shadowRows;
    const row = rows[fromRow];
    const currentValue = row[cellKey];
    const newValue = updated[cellKey];
    if (!_.isEqual(currentValue, newValue)) {
      const updatedRows = rows.map((iterating, idx) => {
        if (fromRow === idx) return { ...iterating, ...updated };
        return iterating;
      });
      this.props.onCellUpdated(row, cellKey, currentValue, newValue)
        .then(() => this.setState({ shadowRows: updatedRows }))
        .catch(e => console.error(e))
        .finally(() => this.setState({ rowUpdatedAlert: false }));
    }
  }

  hackRDGridRender = () => {
    /* O próprio react-data-grid vincula ao evento 'resize' do browser
      a funcionalidade de atualizar as medidas do componente.
      Logo, por ora devemos forçar o resize desta forma.

      Houveram issues em discussão no projeto original para não depender de
      disparar manualmente o resize no DOM, porém foram fechadas.
    */
    window.dispatchEvent(new Event('resize'));
  }

  handleChangeProfile = (idProfile) => {
    changeProfile(this.props.gridName, idProfile).then((res) => {
      this.setState({ currentProfile: idProfile, rawColumnsDef: res.data });
    });
  }

  rowGetter = (rowIdx) => {
    const rows = this.state.shadowRows;
    return rows[rowIdx];
  };

  openConfig = () => {
    this.setState({ showConfig: true });
  }

  openHint = () => {
    this.setState({ showHint: true });
  }

  closeHint = () => {
    this.setState({ showHint: false });
  }

  openAddPerfil = () => {
    this.setState({ showAddPerfil: true, showConfig: false });
  }

  closeConfig = () => {
    this.setState({
      showConfig: false,
      showAlertMessage: false,
      alertMessage: ''
    });
  }

  closeRowUpdatedAlert = () => {
    this.setState({ rowUpdatedAlert: false });
  }

  closeAddPerfil = () => {
    this.setState({ showAddPerfil: false, showConfig: true });
  }

  saveConfig = () => {
    const updateState = (data) => {
      getProfiles(this.props.gridName).then((res) => {
        const newState = {
          ...this.state,
          columnsDef: this.getColumns(this.state.rawColumnsDef),
          showConfig: false,
          profiles: res.data,
          currentProfile: data.object
        };
        this.setState(newState, this.hackRDGridRender);
      });

      getGridDef(this.props.gridName).then((res) => {
        const profileId = res.data.currentProfile ? res.data.currentProfile : -1;
        const columnsDef = this.getColumns(res.data.columnsDef);
        this.setState({
          columnsDef,
          hintsDef: this.getHintsDef(columnsDef),
          rawColumnsDef: columnsDef,
          currentProfile: profileId,
          profiles: res.data.profiles
        }, this.hackRDGridRender);
      });
    };
    updateColumns(this.state.rawColumnsDef)
      .then((res) => {
        updateState(res.data);
      }).catch((err) => {
        this.setState({
          showAlertMessage: true,
          alertMessage: err.response.data.message
        });
      });
  }

  closeContextMenu = () => {
    this.setState({ showContextMenu: false });
  }

  handleShowAlertMessage = () => this.setState(state => ({
    showAlertMessage: !state.showAlertMessage,
    alertMessage: ''
  }))

  reflectColumns = (columnsDef) => {
    this.setState({ columnsDef: this.getColumns(columnsDef) });
  }

  renderAddPerfil = () => {
    return (
      <Modal
        show
        onHide={this.closeAddPerfil}
        dialogClassName="modal-container"
      >
        <Modal.Header closeButton>
          <Modal.Title>Criar Perfil</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="formAddPerfil" className="form add-profile" onSubmit={this.addPerfil}>
            <input name="profileName" type="text" className="form-control" placeholder="Nome" />
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" form="formAddPerfil">Salvar</Button>
          <Button onClick={this.closeAddPerfil}>Fechar</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderAddHint = () => {
    return (
      <Modal
        show
        onHide={this.closeHint}
        dialogClassName="fullscreen-modal-container hint-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Gerenciar Hints</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="columns-hint-content">
            {this.renderHintForms()}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.handleSaveHintsDef}>Salvar</Button>
          <Button onClick={this.closeHint}>Fechar</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderHintForms = () => {
    return this.state.hintsDef.map((hintDef) => {
      return (
        <div className="form-group" key={hintDef.key}>
          <label htmlFor="hint">{hintDef.key}</label>
          <textarea
            rows={5}
            maxLength={254}
            name="hint"
            type="text"
            value={hintDef.hint || ''}
            className="form-control"
            placeholder="Descrição do hint..."
            onChange={(e) => {
              this.handleHintChange({
                id: hintDef.id, hint: e.target.value
              });
            }}
          />
        </div>
      );
    });
  }

  render() {
    const {
      rowHeight,
      highlightActiveRow,
      rowRenderer,
      showCheckbox,
      onRowsSelected,
      onRowsDeselected,
      indexes,
      ...rest
    } = this.props;

    const RowRenderer = (!rowRenderer && (
      <CustomRowRenderer
        columns={this.state.columns}
        activeIdx={this.state.rowIdx}
        highlightActiveRow={highlightActiveRow}
      />
    )) || rowRenderer;

    return (
      <div onContextMenu={this.onContextMenu}>
        <ReactDataGrid
          // Workaround para retirar warning
            enableRowSelect={null}
            rowScrollTimeout={null}
          // Fim do Workaround
          canFilter={false}
          cellNavigationMode="changeRow"
          enableCellSelect
          onGridSort={this.handleGridSort}
          columns={this.state.columnsDef}
          rowHeight={rowHeight}
          rowGetter={this.rowGetter}
          rowsCount={this.state.shadowRows.length}
          onAddFilter={this.handleFilterChange}
          onClearFilters={this.onClearFilters}
          getValidFilterValues={this.getValidFilterValues}
          onCellSelected={this.onCellSelected}
          onColumnResize={this.onColumnResize}
          onGridRowsUpdated={this.handleGridRowsUpdated}
          rowRenderer={RowRenderer}
          rowSelection={{
            showCheckbox,
            onRowsSelected,
            onRowsDeselected,
            selectBy: { indexes },
          }}
          dataChanged={this.state.dataChanged}
          {...rest}
        />
        {this.state.rowUpdatedAlert
          && <Alert
            title="Confirmação"
            message="Confirmar alteração?"
            onClose={this.closeRowUpdatedAlert}
            btnCloseText="Não"
            btnConfirmShow
            btnSaveText="Sim"
            onSave={this.state.saveRowUpdated}
          />
        }
        {/* this.state.showConfig
          &&
          <Modal
            show
            onHide={this.closeConfig}
            dialogClassName="fullscreen-modal-container"
          >
            <Modal.Header>
              {
                this.state.showAlertMessage
                  ? <Alert
                    message={this.state.alertMessage}
                    onClose={this.handleShowAlertMessage}
                    btnCloseText="OK"
                  />
                  : null
              }
              <ColumnsConfigHeader
                currentProfile={this.state.currentProfile}
                onProfileChange={this.handleChangeProfile}
                profiles={this.state.profiles}
              />
            </Modal.Header>
            <Modal.Body>
              <ColumnsConfig
                enableSummary={this.props.enableSummary}
                editableWidth={editableWidth}
                columns={this.state.rawColumnsDef}
                onChange={this.handleChangeColunsDef}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.openAddPerfil}>Criar Novo Perfil</Button>
              <Button onClick={this.saveConfig}>Salvar</Button>
              <Button onClick={this.closeConfig}>Fechar</Button>
            </Modal.Footer>
          </Modal>
        */}
        {/* {this.state.showAddPerfil && this.renderAddPerfil()} */}
        {/* {this.state.showHint && this.renderAddHint()} */}
        {this.state.showContextMenu && (
          <GridContextMenu
            onClearFilters={this.cleanFilters}
            openConfig={this.openConfig}
            hintsPermission={false}
            openHint={this.openHint}
            onClose={this.closeContextMenu}
            x={this.state.contextMenuX}
            y={this.state.contextMenuY}
          />
        )}
      </div>
    );
  }
}

export default Grid;
